import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=6bef75a8&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=js"
export * from "./productManage.vue?vue&type=script&lang=js"
import style0 from "./productManage.vue?vue&type=style&index=0&id=6bef75a8&prod&scoped=true&lang=css"
import style1 from "./productManage.vue?vue&type=style&index=1&id=6bef75a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef75a8",
  null
  
)

export default component.exports